export const useDataSpeed = () => {

    const {
        $gsap: gsap,
        $ScrollTrigger: ScrollTrigger
    } = useNuxtApp();

    const effectElements = gsap.utils.toArray("[data-speed]");
    if (effectElements) {
        gsap.to("[data-speed]", {
            y: (i, el) =>  parseFloat(el.getAttribute("data-speed")) * ScrollTrigger.maxScroll(window),
            ease: "none",
            scrollTrigger: {
                start: 0,
                end: "max",
                invalidateOnRefresh: true,
                scrub: 0
            }
        });
    }
}